var map = {
	"./calendar.svg": "287d",
	"./date-range.svg": "ad41",
	"./face.svg": "48e4",
	"./jyq.svg": "255e",
	"./leave-person.svg": "1656",
	"./qqtels.svg": "8280",
	"./to-arrow.svg": "5dc1",
	"./touch.svg": "bb9d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";